<script setup lang="ts">
import { } from 'vue'

interface Props {
  modelValue?: boolean
  imageUrl?: string
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: false,
  imageUrl: '',
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
}>()

const imageLoading = ref(true)

const closeDialog = () => {
  emit('update:modelValue', false)
}
</script>

<template>
  <CustomVDialog
    :model-value="modelValue"
    fullscreen
    scrollable
    transition="dialog-bottom-transition"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <template #default>
      <VContainer class="full-screen-container">
        <!-- Loading overlay -->
        <VOverlay
          v-model="imageLoading"
          persistent
          contained
          class="align-center justify-center"
          :close-on-content-click="false"
        >
          <VProgressCircular
            indeterminate
            color="primary"
          />
        </VOverlay>

        <!-- Image -->
        <VImg
          :src="imageUrl"
          class="full-screen-image"
          alt="Full screen image"
          @loadstart="imageLoading = true"
          @load="imageLoading = false"
        />

        <!-- Close button -->
        <VBtn
          class="close-button"
          icon
          color="white"
          @click="closeDialog"
        >
          <VIcon icon="mdi-close" />
        </VBtn>
      </VContainer>
    </template>
  </CustomVDialog>
</template>

<style scoped lang="scss">
.full-screen-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: black;
  padding: 16px; // Top and bottom margins
}

.full-screen-image {
  max-width: 100%;
  max-height: 100%;
  margin: 8px 0; // Add some top and bottom margin to the image
  object-fit: contain;
}

.close-button {
  z-index: 3000;
  width: 32px;
  height: 32px;
  position: absolute;
  top: 0;
  right: 0;
  margin: 8px;

  border-radius: 0.375rem;
  background-color: rgb(var(--v-theme-surface)) !important;
  block-size: 2rem;
  inline-size: 2rem;
  inset-block-start: 0;
  inset-inline-end: 0;
  transform: translate(0.5rem, -0.5rem);
}
</style>
